import * as Types from '../../../../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

/*
* This was automatically generated on by @graphql-codegen.
* DO NOT MANUALLY EDIT !!!
* Please refer to https://github.com/wistia/wistia/blob/main/frontend/graphql/README.md for more information.
* Last Updated: Tue Nov 04 2025 21:44:02 GMT+0000 (Coordinated Universal Time)
*/

const defaultOptions = {} as const;
export type AddCommentReactionMutationVariables = Types.Exact<{
  input: Types.AddCommentReactionInput;
}>;


export type AddCommentReactionMutation = { __typename?: 'Mutation', addCommentReaction?: { __typename?: 'AddCommentReactionPayload', teamComment: { __typename?: 'TeamComment', id: string } } | null | undefined };

export type RemoveCommentReactionMutationVariables = Types.Exact<{
  input: Types.RemoveCommentReactionInput;
}>;


export type RemoveCommentReactionMutation = { __typename?: 'Mutation', removeCommentReaction?: { __typename?: 'RemoveCommentReactionPayload', teamComment: { __typename?: 'TeamComment', id: string } } | null | undefined };


export const AddCommentReactionDocument = gql`
    mutation AddCommentReaction($input: AddCommentReactionInput!) {
  addCommentReaction(input: $input) {
    teamComment {
      id
    }
  }
}
    `;
export type AddCommentReactionMutationFn = Apollo.MutationFunction<AddCommentReactionMutation, AddCommentReactionMutationVariables>;

/**
 * __useAddCommentReactionMutation__
 *
 * To run a mutation, you first call `useAddCommentReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommentReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommentReactionMutation, { data, loading, error }] = useAddCommentReactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCommentReactionMutation(baseOptions?: Apollo.MutationHookOptions<AddCommentReactionMutation, AddCommentReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommentReactionMutation, AddCommentReactionMutationVariables>(AddCommentReactionDocument, options);
      }
export type AddCommentReactionMutationHookResult = ReturnType<typeof useAddCommentReactionMutation>;
export type AddCommentReactionMutationResult = Apollo.MutationResult<AddCommentReactionMutation>;
export type AddCommentReactionMutationOptions = Apollo.BaseMutationOptions<AddCommentReactionMutation, AddCommentReactionMutationVariables>;
export const RemoveCommentReactionDocument = gql`
    mutation RemoveCommentReaction($input: RemoveCommentReactionInput!) {
  removeCommentReaction(input: $input) {
    teamComment {
      id
    }
  }
}
    `;
export type RemoveCommentReactionMutationFn = Apollo.MutationFunction<RemoveCommentReactionMutation, RemoveCommentReactionMutationVariables>;

/**
 * __useRemoveCommentReactionMutation__
 *
 * To run a mutation, you first call `useRemoveCommentReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCommentReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCommentReactionMutation, { data, loading, error }] = useRemoveCommentReactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCommentReactionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCommentReactionMutation, RemoveCommentReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCommentReactionMutation, RemoveCommentReactionMutationVariables>(RemoveCommentReactionDocument, options);
      }
export type RemoveCommentReactionMutationHookResult = ReturnType<typeof useRemoveCommentReactionMutation>;
export type RemoveCommentReactionMutationResult = Apollo.MutationResult<RemoveCommentReactionMutation>;
export type RemoveCommentReactionMutationOptions = Apollo.BaseMutationOptions<RemoveCommentReactionMutation, RemoveCommentReactionMutationVariables>;